module.exports = {
  "country": "IL",
  "artist": "Gali Atari & Milk and Honey",
  "song": "Hallelujah",
  "year": "1979",
  "place": "1",
  "spotify": "6f85s8fOLR2i6Acur19zZk"
};